import React, { useEffect, useRef, useState } from "react"
import { ReactComponent as CloseImg } from "../images/close-gray.svg"
import styled from "styled-components"
import copy from "copy-to-clipboard"
import { db, fieldValue, logUserEvent } from "../common/firebase.utils"
import { useUserInfo } from "../hooks/useUserInfo"
import useToast from "../hooks/useToast"

export default function TemplateEditPopup({
  template,
  onClose
}: {
  template: any
  onClose: () => void
}) {
  const { userId } = useUserInfo()
  const textAreaRef = useRef<HTMLTextAreaElement>(null)
  const toast = useToast()

  const [isCopying, setIsCopying] = useState(false)

  const copyCountIncreased = useRef(false)

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.focus()
    }
  }, [])

  const onClickCopy = () => {
    const editedContent = textAreaRef.current?.value?.trim()
    if (!editedContent) return
    if (isCopying) return

    setIsCopying(true)

    copy(editedContent, { format: "text/plain" })

    // 편집창에서 여러번 복사해도 템플릿 복사 횟수는 한번만 증가시킴
    if (!copyCountIncreased.current) {
      copyCountIncreased.current = true

      db.collection("templates")
        .doc(template.id)
        .update({
          pasted: fieldValue.increment(1),
          lastcopiedat: fieldValue.serverTimestamp()
        })
      // TODO: Card 복사횟수 업데이트
      // .then(() => {
      //   setCopyCount(copyCount + 1)
      // })
    }

    db.collection("statistics")
      .doc("actions")
      .update({
        copy: fieldValue.increment(1),
        editCopy: fieldValue.increment(1)
      })

    // 사용자 복사 내역 저장.
    if (userId) {
      const _situationid = template.situationid
      db.collection("copies").add({
        userid: userId,
        templateid: template.id,
        situationid: _situationid,
        writerid: template.writerid,
        createdat: fieldValue.serverTimestamp(),
        editedcontent: editedContent
      })
      db.collection("users")
        .doc(userId)
        .get()
        .then(doc => {
          if (!doc.exists) return
          const situationCopies = doc.data()?.situationCopyCount || {}
          situationCopies[_situationid] =
            (situationCopies[_situationid] || 0) + 1
          doc.ref.update({
            situationCopyCount: situationCopies
          })
        })
    }

    logUserEvent("editCopy")

    toast.showWithClose({
      text: "템플릿이 복사되었습니다."
    })
    setIsCopying(false)
  }

  return (
    <div className="fixed top-0 left-0 w-full h-full z-[100]">
      <div
        className="bg-white shadow-xl md:w-[704px] md:h-[600px] md:absolute md:bottom-0 h-full md:right-[8%] md:rounded-tl-lg md:rounded-tr-lg overflow-hidden"
        onClick={e => {
          e.stopPropagation()
        }}
      >
        <header className="flex items-center justify-between h-[53px] bg-[#333333] text-white pl-6 pr-4">
          <span className="text-xl font-semibold">템플릿 편집</span>
          <button onClick={onClose}>
            <CloseImg />
          </button>
        </header>
        <div className="py-6 px-8 text-right">
          <Content>
            <p>템플릿 내용</p>
            <div id="textarea-container">
              <textarea
                ref={textAreaRef}
                className="no-scrollbar"
                defaultValue={template.content}
              ></textarea>
            </div>
          </Content>
          <button
            className="mt-4 w-full md:w-[200px] rounded-lg bg-primary font-medium text-lg text-white leading-[56px] disabled:opacity-50 disabled:cursor-progress"
            onClick={onClickCopy}
            disabled={isCopying}
          >
            복사하기
          </button>
        </div>
      </div>
    </div>
  )
}

const Content = styled.div`
  text-align: left;
  p {
    font-size: 12px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 8px;
  }
  #textarea-container {
    position: relative;
    border: 1px solid #232a34;
    border-radius: 10px;
    box-sizing: border-box;
    width: 100%;
    height: 366px;
    padding: 16px;
  }
  textarea {
    border: none;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    outline: none;
    overflow: auto;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    resize: none;
    font-size: 14px;
    line-height: 20px;
    word-break: keep-all;
    &::placeholder {
      color: #c7c7c7;
    }
  }
  .radio-container {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }
  @media (max-width: 800px) {
    #textarea-container {
      padding: 16px;
      height: calc(100vh - 204px);
    }
    textarea {
      font-size: 1rem;
    }
  }
`
